




import Vue from 'vue';

import UserEditForm from '@/common/components/users/UserEditForm.vue';
import { UserType } from '@/common/components/users/users.types';

export default Vue.extend({
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      title: 'Edit user' as string,
      UserType,
    };
  },
  created() {
    if (this.title) {
      document.title = this.title;
    }
  },
  components: {
    UserEditForm,
  },
});
